import {
  FormControl,
  Select,
  FormHelperText,
  SelectProps,
  MenuItem,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { KFieldLabel } from 'components/core/KFieldLabel'
import { isEmpty } from 'lodash'
import { KeyValue } from 'models'
import {
  ForwardRefExoticComponent,
  ForwardedRef,
  RefAttributes,
  forwardRef,
} from 'react'

export interface KSelectProps extends Omit<SelectProps, 'variant'> {
  helperText?: string
  labelSize?: 'small' | 'medium' | 'large'
  ref?: ForwardedRef<HTMLDivElement>
  options?: KeyValue[]
}

export const KSelect: ForwardRefExoticComponent<
  Omit<KSelectProps, 'ref'> & RefAttributes<HTMLDivElement>
> = forwardRef((props, ref) => {
  const {
    label,
    labelSize,
    required,
    options,
    helperText,
    disabled,
    sx,
    value,
    ...restProps
  } = props
  const theme = useTheme()

  return (
    <FormControl
      sx={{
        ...sx,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
      disabled={disabled}
      fullWidth={props.fullWidth}
      ref={ref}
    >
      <KFieldLabel
        labelSize={labelSize}
        sx={{
          marginBottom: 1,
          [theme.breakpoints.down('sm')]: {
            marginBottom: 0.5,
          },
        }}
        required={required}
      >
        {label}
      </KFieldLabel>
      <Select
        {...(restProps as any)}
        inputProps={{ readOnly: disabled }}
        value={value || ''}
        sx={{
          borderRadius: 4,
          height: 56,
          '&:hover': {
            backgroundColor: theme.palette.grey['A100'],
          },
          [theme.breakpoints.down('sm')]: {
            borderRadius: 3.5,
            height: 52,
          },
        }}
      >
        {options?.map((item, i) => (
          <MenuItem key={i} value={item.value}>
            {item.key}
          </MenuItem>
        ))}
      </Select>
      {!isEmpty(helperText) && (
        <FormHelperText
          error={props.error}
          sx={{ fontSize: theme.typography.subtitle1.fontSize }}
        >
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
})
